import { defineAgenda } from '@/shared/navigation/core';

/**
 * Agenda seznamu obchodních případů — pilotní univerzální ListPage
 * (engine `@/shared/ui/list-page`, šablona `businessCaseListPage.tsx`).
 */
export const businessCaseListAgenda = defineAgenda({
  id: 'reservations.business-cases',
  path: 'reservations/business-cases',
  open: {},
  state: {},
  title: 'Obchodní případy',
  icon: 'doc',
});
